import VueSearchLocator from './js/vue-search-locator';
export default VueSearchLocator;
